import React from "react";

export const Chapter = (props) => {
    let {header, paragraph} = props;
    return (<div>
            <h2>{header}</h2>
            <p className="description-text">{paragraph}</p>
        </div>
    )
};